import { useQuery } from '@tanstack/react-query';
import type { SystemStatusResponse } from './types';

const SYSTEM_STATUS_ENDPOINT = 'https://status.customerio.com/api/v2/status.json';

async function fetchSystemStatus(): Promise<SystemStatusResponse> {
  const response = await fetch(SYSTEM_STATUS_ENDPOINT, {
    method: 'GET',
    redirect: 'follow',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch system status: ${response.statusText}`);
  }

  return await response.json();
}

export function useSystemStatus() {
  const query = useQuery({
    queryKey: ['systemStatus'],
    queryFn: fetchSystemStatus,
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    staleTime: 5 * 60 * 1000, // Consider data stale after 5 minutes
  });

  return {
    indicator: query.data?.status.indicator,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
